// extracted by mini-css-extract-plugin
module.exports = {"body":"i_Bl","arrows-space":"i_Bm","slider":"i_Bn"};